import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { map, find } from "lodash";

@Component({
  selector: "group-status-filters",
  templateUrl: "./group-status-filters.component.html",
  styleUrls: ["./group-status-filters.component.scss"],
})
export class GroupStatusFiltersComponent implements OnInit {
  @Input() groupStatusFilters: Array<string>;
  @Output() groupStatusFilterChange = new EventEmitter();

  groupStatusOptions = [
    {
      name: "Meets criteria",
      value: "in_group_and_meets_criteria",
      checked: false,
    },
    {
      name: "Does not meet criteria",
      value: "in_group_but_does_not_meet_criteria",
      checked: false,
    },
    {
      name: "Recommended",
      value: "out_of_group_but_meets_criteria",
      checked: false,
    },
  ];

  constructor() {}

  ngOnInit() {
    this.groupStatusOptions = map(this.groupStatusOptions, (option) => {
      return {
        ...option,
        checked: this.groupStatusFilters.indexOf(option.value) > -1,
      };
    });
    this.groupStatusFilterChange.emit(this.groupStatusFilters);
  }

  emitSelectedOptions() {
    let selectedOptions = this.groupStatusOptions
      .filter((opt) => opt.checked)
      .map((opt) => opt.value);
    this.groupStatusFilterChange.emit(selectedOptions);
  }
}
